import React from 'react';
import { FileSearch } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-24 pb-16 bg-noir-bg overflow-hidden border-b border-noir-border" data-id="element-55">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(#1C1C1C 1px, transparent 1px), linear-gradient(90deg, #1C1C1C 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-56"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-57">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-58">
          {/* Text Content */}
          <div className="flex flex-col space-y-8" data-id="element-59">
            <div className="inline-flex items-center space-x-2 bg-noir-card border border-noir-border px-3 py-1 w-fit rounded-sm" data-id="element-60">
              <FileSearch className="w-4 h-4 text-noir-alert" data-id="element-61" />
              <span className="text-xs font-bold tracking-widest text-noir-muted uppercase font-mono" data-id="element-62">
                Archivo Confidencial
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-noir-text leading-tight uppercase tracking-tight" data-id="element-63">
              Expediente Pareja: <br data-id="element-64" />
              <span className="text-noir-alert" data-id="element-65">El Juego de los Casos</span>
            </h1>

            <p className="text-lg sm:text-xl text-noir-muted leading-relaxed border-l-2 border-noir-alert pl-4" data-id="element-66">
              Resuelvan el misterio de "otros" para salvar el suyo: La
              experiencia digital que rompe el silencio y reconecta a las
              parejas en 48 horas.
            </p>

            {/* Mobile Video Content (Visible only on small screens) */}
            <div className="relative w-full block lg:hidden my-6" data-id="element-67">
              <div className="relative rounded-sm overflow-hidden border border-noir-border bg-noir-card aspect-video flex items-center justify-center shadow-[0_0_40px_rgba(61,0,0,0.3)]" data-id="element-68">
                <div className="absolute inset-0 bg-noir-crimson/10 mix-blend-overlay z-10 pointer-events-none" data-id="element-69"></div>
                <video className="w-full h-full object-cover grayscale-[30%] contrast-125" autoPlay loop muted playsInline data-id="element-70">
                  <source src="https://cdn.magicpatterns.com/uploads/tGr3wWs75V9NxQqVBkcydY/iPad_Pro_scrolling_202603260245.mp4" type="video/mp4" data-id="element-71" />
                  Tu navegador no soporta el elemento de video.
                </video>

                {/* Forensic UI Overlays */}
                <div className="absolute top-4 left-4 w-4 h-4 border-t-2 border-l-2 border-noir-alert z-20" data-id="element-72"></div>
                <div className="absolute top-4 right-4 w-4 h-4 border-t-2 border-r-2 border-noir-alert z-20" data-id="element-73"></div>
                <div className="absolute bottom-4 left-4 w-4 h-4 border-b-2 border-l-2 border-noir-alert z-20" data-id="element-74"></div>
                <div className="absolute bottom-4 right-4 w-4 h-4 border-b-2 border-r-2 border-noir-alert z-20" data-id="element-75"></div>

                <div className="absolute top-4 right-10 flex space-x-1 z-20" data-id="element-76">
                  <div className="w-1 h-3 bg-noir-alert animate-pulse" data-id="element-77"></div>
                  <div className="w-1 h-3 bg-noir-alert animate-pulse delay-75" data-id="element-78"></div>
                  <div className="w-1 h-3 bg-noir-alert animate-pulse delay-150" data-id="element-79"></div>
                </div>
              </div>
            </div>

            <div className="pt-2 lg:pt-4 flex flex-col items-start space-y-3 w-full" data-id="element-80">
              <a href="#final-cta" onClick={e => {
              e.preventDefault();
              document.getElementById('final-cta')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="inline-flex flex-col items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-noir-alert border border-transparent rounded-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-noir-alert focus:ring-offset-noir-bg w-full sm:w-auto uppercase tracking-wider text-center" data-id="element-81">
                <span data-id="element-82">Descargar Expediente</span>
                <span className="text-sm font-normal opacity-90 mt-1 normal-case tracking-normal" data-id="element-83">
                  por sólo $21.900 COP
                </span>
              </a>
            </div>
          </div>

          {/* Desktop Video Content */}
          <div className="relative mx-auto w-full max-w-2xl lg:max-w-none hidden lg:block" data-id="element-84">
            <div className="relative rounded-sm overflow-hidden border border-noir-border bg-noir-card aspect-video flex items-center justify-center shadow-[0_0_40px_rgba(61,0,0,0.3)]" data-id="element-85">
              <div className="absolute inset-0 bg-noir-crimson/10 mix-blend-overlay z-10 pointer-events-none" data-id="element-86"></div>
              <video className="w-full h-full object-cover grayscale-[30%] contrast-125" autoPlay loop muted playsInline data-id="element-87">
                <source src="https://cdn.magicpatterns.com/uploads/tGr3wWs75V9NxQqVBkcydY/iPad_Pro_scrolling_202603260245.mp4" type="video/mp4" data-id="element-88" />
                Tu navegador no soporta el elemento de video.
              </video>

              {/* Forensic UI Overlays */}
              <div className="absolute top-4 left-4 w-4 h-4 border-t-2 border-l-2 border-noir-alert z-20" data-id="element-89"></div>
              <div className="absolute top-4 right-4 w-4 h-4 border-t-2 border-r-2 border-noir-alert z-20" data-id="element-90"></div>
              <div className="absolute bottom-4 left-4 w-4 h-4 border-b-2 border-l-2 border-noir-alert z-20" data-id="element-91"></div>
              <div className="absolute bottom-4 right-4 w-4 h-4 border-b-2 border-r-2 border-noir-alert z-20" data-id="element-92"></div>

              <div className="absolute top-4 right-10 flex space-x-1 z-20" data-id="element-93">
                <div className="w-1 h-3 bg-noir-alert animate-pulse" data-id="element-94"></div>
                <div className="w-1 h-3 bg-noir-alert animate-pulse delay-75" data-id="element-95"></div>
                <div className="w-1 h-3 bg-noir-alert animate-pulse delay-150" data-id="element-96"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}